<template>
  <div>
    <div class="pa-1">
      <v-card>
        <v-card-title>{{ $t('Purchase by Date') }}</v-card-title>
        <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
        <template v-if="purchaseByDateSeries">
          <apexchart
            ref="purchasebydate"
            type="area"
            height="350"
            :options="purchasebydate"
            :series="purchaseByDateSeries"
          ></apexchart>
        </template>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'
import DashboardGraphLoading from '@/components/view/dashboard/DashboardGraphLoading'

export default {
  props: ['selectedDate', 'filter'],
  data: function () {
    return {
      loading: false,
      purchaseByDateSeries: undefined,
      purchasebydate: {
        chart: {
          height: 350,
          type: 'area'
        },
        stroke: {
          curve: 'smooth'
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%'
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime'
        },
        yaxis: {
          title: {
            text: 'Purchase'
          },
          tickAmount: 1,
          labels: {
            formatter: function (val, index) {
              return val.toFixed(0)
            }
          }
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy'
          },
          y: {
            formatter: function (val) {
              return val + ' Purchases'
            }
          }
        }
      }
    }
  },
  components: {
    DashboardGraphLoading,
    apexchart: VueApexCharts
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  mounted: function () {
    this.getPurchaseByDate()
  },
  methods: {
    getPurchaseByDate() {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid, // required
        start_date: moment(vm.selectedDate.start).format('YYYY-MM-DD'), // YYYY-MM-DD
        end_date: moment(vm.selectedDate.end).format('YYYY-MM-DD') // YYYY-MM-DD
      }
      vm.loading = true
      api.getLamyOverview2PurchaseByDate(data, (err, response) => {
        if (response.responsecode == 200) {
          let data = []
          $.each(response.data, function (index, val) {
            data.push([moment(val['date']).format('YYYY-MM-DDT00:00:00'), parseInt(val['total'])])
          })

          vm.purchaseByDateSeries = [{ name: '', data: data }]
          vm.$emit('dataPurchaseDate', response.data)
          vm.loading = false
        } else {
          console.log(err)
          return
        }
      })
    }
  },
  watch: {
    loading: function () {},
    selectedDate: {
      handler: function (newValue) {
        this.getPurchaseByDate()
      },
      deep: true
    },
    filter: function () {
      this.getPurchaseByDate()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/PurchaseBehavior/PurchaseByDate.vue